import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./contexts/AuthContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import { ThemeProvider } from "./contexts/ThemeContext";

// Suppress ResizeObserver loop error (benign browser/React quirk)
// This patches ResizeObserver globally to catch and ignore the specific error
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
  constructor(callback: ResizeObserverCallback) {
    super((entries, observer) => {
      // Use requestAnimationFrame to prevent the loop error
      window.requestAnimationFrame(() => {
        callback(entries, observer);
      });
    });
  }
};

const rootElement = document.getElementById("root") as HTMLElement;

// The boot screen in public/index.html covers the page while this bundle
// downloads; drop it as soon as React puts the app into #root.
const bootSplash = document.getElementById("boot-splash");
if (bootSplash) {
  const observer = new MutationObserver(() => {
    if (rootElement.childElementCount > 0) {
      observer.disconnect();
      bootSplash.remove();
    }
  });
  observer.observe(rootElement, { childList: true });
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <LanguageProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </LanguageProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
